import { React, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { main_paige_title } from "../../constants/constants";
import CheckoutForm from "./CheckoutForm";
import { setMyCartModalVisibility } from "../../store/actions";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_API_KEY);

const Checkout = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems);
  const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    const products = cartItems.map((element) => ({
      id: element.product_id,
      quantity: element.product_quantity,
    }));
    // Create PaymentIntent as soon as the page loads
    fetch(process.env.REACT_APP_BACKEND_ENDPOINT + "/v1/payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: products }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));

    // Hide MyCart sidebar if visible
    if (myCartModalVisibility) {
      dispatch(setMyCartModalVisibility(!myCartModalVisibility));
    }
  }, []);

  const appearance = { theme: "stripe" };
  const options = { clientSecret, appearance };

  return (
    <div>
      <Helmet>
        <title property="title">{main_paige_title} - Kasse</title>
      </Helmet>
      <Header />
      <div className="App">
        {clientSecret ? (
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm />
          </Elements>
        ) : (
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <div style={{ width: "100%", height: "200vh" }}>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Checkout;